import { render, staticRenderFns } from "./LeaderboardItems.vue?vue&type=template&id=0be7deda&"
import script from "./LeaderboardItems.vue?vue&type=script&lang=js&"
export * from "./LeaderboardItems.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/EventsTopFundraisersLayout.css?vue&type=style&index=0&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports